define('boxes/events/loginEvent',[], function() {
    'use strict';

    var LoginEvent = {};
    LoginEvent.VERIFY_EMAIL = 'VERIFY_EMAIL';
	LoginEvent.SKIP_EMAIL_VERIFICATION = 'SKIP_EMAIL_VERIFICATION';
    LoginEvent.VERIFY_POSTAL_AND_MOBILE = 'VERIFY_POSTAL_AND_MOBILE';
    LoginEvent.CHANGE_PASSWORD = 'CHANGE_PASSWORD';
    LoginEvent.FORGOT_PASSWORD = 'FORGOT_PASSWORD';
    LoginEvent.SET_LOGIN_DONE_CALLBACK = 'SET_LOGIN_DONE_CALLBACK';
    LoginEvent.SET_BACK_TO_LOGIN_CALLBACK = 'SET_BACK_TO_LOGIN_CALLBACK';
    LoginEvent.EMAIL_IS_VERIFIED = 'EMAIL_IS_VERIFIED';
    return LoginEvent;
});

